import { useFadeIn } from '../../../hooks/useFadeIn';

export default function Flow() {
  const { ref, isVisible } = useFadeIn({ threshold: 0.1 });

  const steps = [
    {
      number: '1',
      title: 'お問い合わせフォームから\nご連絡',
      description: 'まずはお気軽にお問い合わせください。ご相談内容をお聞かせいただきます。',
      icon: 'ri-mail-send-line'
    },
    {
      number: '2',
      title: 'オンラインでの\nヒアリング・ご提案',
      description: '貴社の課題やニーズをお伺いし、最適なプランをご提案いたします。',
      icon: 'ri-presentation-line'
    },
    {
      number: '3',
      title: '契約・導入準備',
      description: 'ご契約後、スムーズな導入に向けて必要な準備を進めます。',
      icon: 'ri-file-text-line'
    },
    {
      number: '4',
      title: '運用開始・定期フォロー',
      description: 'サービス開始後も定期的にフォローアップし、継続的にサポートします。',
      icon: 'ri-customer-service-2-line'
    }
  ];

  return (
    <section className="min-h-[75vh] py-24 bg-[#FDFBF7] flex items-center">
      <div 
        ref={ref}
        className={`max-w-7xl mx-auto px-6 w-full transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A3B5C] mb-4">
            導入の流れ
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className={`relative transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="text-center group cursor-pointer">
                <div className="mb-6 flex justify-center">
                  <div className="w-16 h-16 rounded-full bg-[#E8F4F8] flex items-center justify-center text-2xl font-bold text-[#1A3B5C] group-hover:bg-[#4A7BA7] group-hover:text-white transition-all duration-300">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="text-lg font-bold text-[#1A3B5C] mb-4 whitespace-pre-line leading-tight min-h-[3rem]">
                  {step.title}
                </h3>
                
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  {step.description}
                </p>
                
                <div className="flex justify-center">
                  <i className={`${step.icon} text-3xl text-[#1A3B5C] opacity-30`}></i>
                </div>
              </div>

              {/* Arrow between steps */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-4 w-8 h-0.5 border-t-2 border-dashed border-gray-300">
                  <i className="ri-arrow-right-line text-gray-300 absolute -right-2 -top-3"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
